(function(angular, schoolwork12) {
    'use strict';
 
    angular.module(schoolwork12.app.auth.name)
    .directive('ssoClick', 
               ['authentication', '$window',  
                 function (authentication, $window) {
                    return {
                            restrict: 'A',
                            link: function(scope, element, attributes) {
                                element.bind('click', 
                                    function (event) {
                                        var newKeycode = authentication.getCurrentUser().keycode;  
                                        authentication.refreshKeycode(authentication.getCurrentUser().keycode).then(function(response) {
                                            newKeycode = response.data._keycode;
                                           // console.info("newKeycode: ".concat(newKeycode));
                                        });
                                        console.info('attributes: '.concat(attributes.ssoClick).concat(newKeycode).concat(', ').concat(attributes.target));
                                        if (attributes.target) {
                                            $window.open(                                             
                                                attributes.ssoClick.concat(newKeycode),
                                                attributes.target
                                            );
                                        }
                                        else {
                                            $window.location.href=attributes.ssoClick.concat(newKeycode);
                                        }
                                    });
                                }
                            }
                    }
                ]);
    
}(angular, schoolwork12));